/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        viewBox="0 0 77.89 95.58"
        width="77.89"
        height="95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M38.98 19.29c-12.46 0-22.59 10.13-22.59 22.59 0 7.29 3.33 13.57 6.27 19.11 2.41 4.55 4.5 8.48 4.5 12.3v2.37l23.4-3.34c.35-3.47 2.32-7.08 4.55-11.19 3.03-5.57 6.46-11.88 6.46-19.24 0-12.46-10.13-22.59-22.59-22.59M25.91 78.36a1.26 1.26 0 0 1-1.25-1.25V73.3c0-3.19-1.95-6.87-4.21-11.13-3.07-5.8-6.56-12.37-6.56-20.28 0-13.83 11.26-25.09 25.09-25.09s25.09 11.26 25.09 25.09c0 8-3.6 14.61-6.77 20.44-2.31 4.25-4.31 7.92-4.31 11.09 0 .62-.46 1.15-1.07 1.24l-25.84 3.69c-.06 0-.12.01-.18.01"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M27.65 83.66c-.61 0-1.14-.44-1.23-1.06-.1-.68.37-1.32 1.05-1.42l23.6-3.58c.68-.11 1.32.37 1.42 1.05.1.68-.37 1.32-1.05 1.42l-23.6 3.58c-.06.01-.13.01-.19.01"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M27.65 88.43c-.61 0-1.14-.44-1.23-1.06-.1-.68.37-1.32 1.05-1.42l23.6-3.58c.68-.1 1.32.37 1.42 1.05.1.68-.37 1.32-1.05 1.42l-23.6 3.58c-.06 0-.13.01-.19.01"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M39.33 95.58c-5 0-10.07-1.66-10.07-4.83a1.25 1.25 0 0 1 2.5 0c0 .69 2.65 2.33 7.57 2.33s7.57-1.65 7.57-2.33.56-1.25 1.25-1.25 1.25.56 1.25 1.25c0 3.17-5.07 4.83-10.07 4.83"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M39.71 10.59c-.21.15-.46.24-.73.24-.69 0-1.25-.56-1.25-1.25V1.25a1.25 1.25 0 0 1 2.5 0v8.33c0 .42-.2.78-.52 1.01"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M20.25 16.81c-.39 0-.77-.18-1.01-.51l-4.9-6.74c-.4-.56-.28-1.34.28-1.75a1.25 1.25 0 0 1 1.75.28l4.9 6.74c.41.56.28 1.34-.28 1.75-.22.16-.48.24-.73.24M9.91 30.46c-.31.23-.73.31-1.12.18L.87 28.07c-.66-.21-1.01-.92-.8-1.58.21-.66.92-1.02 1.57-.8l7.92 2.57a1.251 1.251 0 0 1 .35 2.2"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M57.71 16.81c-.25 0-.51-.08-.73-.24a1.26 1.26 0 0 1-.28-1.75l4.9-6.74c.4-.56 1.19-.68 1.74-.28.56.41.68 1.19.28 1.75l-4.89 6.74c-.24.34-.62.51-1.01.51M67.99 30.45c-.21-.15-.37-.36-.45-.62-.21-.66.15-1.36.8-1.58l7.92-2.57c.66-.21 1.36.15 1.57.8.21.66-.15 1.36-.8 1.57l-7.92 2.57c-.39.13-.81.05-1.12-.18"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M38.67 58.79c-1.07 0-1.96.35-2.65 1.04-.69.69-1.04 1.59-1.04 2.67s.35 1.96 1.04 2.65c.69.69 1.58 1.04 2.65 1.04s1.95-.35 2.64-1.04c.68-.69 1.03-1.58 1.03-2.65s-.35-1.98-1.03-2.67-1.57-1.04-2.64-1.04ZM46.54 33.91c-1.88-1.66-4.36-2.5-7.36-2.5-3.35 0-5.94.93-7.69 2.75-1.74 1.81-2.68 4.04-2.81 6.63l-.03.52h4.91l.04-.46c.11-1.52.64-2.68 1.59-3.56.95-.86 2.24-1.3 3.83-1.3s2.84.43 3.76 1.27c.92.84 1.36 1.88 1.36 3.17 0 1.12-.26 2.06-.76 2.79-.52.76-1.43 1.54-2.69 2.31-1.63.97-2.86 2.04-3.65 3.2-.8 1.18-1.21 2.6-1.19 4.21v2.61h5.02v-1.99c0-1.1.23-2.01.7-2.69.47-.71 1.42-1.48 2.8-2.29 1.52-.92 2.76-2.07 3.66-3.42.92-1.37 1.38-3.03 1.38-4.92 0-2.51-.96-4.63-2.87-6.31Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'LightbulbWithQuestionMarkIcon';

export default Icon;
